(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vc-darmflora-landing"]) return;
  try {
    
(() => {
  const form = document.getElementById('pack-form');
  const base = Number(form.dataset.price); const total = {1:base,2:Math.round(base*.9)*2,3:Math.round(base*.85)*3}; const fmt = n => new Intl.NumberFormat('de-DE',{style:'currency',currency:form.dataset.currency}).format(n/100); const prices=Object.fromEntries(Object.entries(total).map(([q,n])=>[q,fmt(n)]));
  const daily=Object.fromEntries(Object.entries(total).map(([q,n])=>[q,fmt(Math.round(n/(Number(q)*90)))]));
  function update() {
    const selected = form.querySelector('input[name="quantity"]:checked');
    const q = selected.value;
    const label = q === '1' ? '1 Dose' : q + 'er-Pack';
    document.getElementById('bundle-meta').value = JSON.stringify({bundle_id: 'ymkp', bundle_option_id: selected.dataset.option});
    if(!document.getElementById('pack-buy').disabled) document.getElementById('pack-buy').textContent = label + ' in den Warenkorb ↗';
    document.getElementById('pack-note').textContent = prices[q] + ' gesamt · rund ' + daily[q] + ' pro Tagesdosis';
  }
  form.addEventListener('change', update);
  form.addEventListener('submit', update);
  window.addEventListener('pageshow', update);
  update();
})();

(() => {
  const styleId = 'vc-darm-privacy-position';
  let observer;
  function positionPrivacy() {
    if (!document.getElementById('vc-darm-lp')) return false;
    const root = document.getElementById('usercentrics-cmp-ui')?.shadowRoot;
    if (!root) return false;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = '@media(max-width:620px){.privacyButton{position:relative!important;inset:auto!important;margin:20px 24px!important;--button-size:44px}}';
      root.appendChild(style);
    }
    if (!observer) {
      observer = new MutationObserver(positionPrivacy);
      observer.observe(root, {childList:true});
    }
    return true;
  }
  if (!positionPrivacy()) {
    let attempts = 0;
    const timer = setInterval(() => {if (positionPrivacy() || ++attempts >= 40) clearInterval(timer);}, 500);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-kur-rebuild"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('vcKurLanding');
  if (!root) return;
  var variants = { 'none|none|none':64926625104221,'globuli|none|none':64926625038685,'none|vanille|none':64926571692381,'none|erdbeere|none':64926571561309,'none|schoko|none':64926571331933,'globuli|vanille|none':64926570873181,'globuli|erdbeere|none':64926570742109,'globuli|schoko|none':64926570512733,'none|vanille|shaker':64926571757917,'none|erdbeere|shaker':64926571626845,'none|schoko|shaker':64926571397469,'globuli|vanille|shaker':64926570938717,'globuli|erdbeere|shaker':64926570807645,'globuli|schoko|shaker':64926570578269 };
  var state = { data:null, busy:false };
  var q = function (s) { return root.querySelector(s); };
  var value = function (name) { var e=q('input[name="'+name+'"]:checked'); return e ? e.value : 'none'; };
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:'EUR'});
  function currentId(){ var shake=value('kurShake'), shaker=shake==='none'?'none':value('kurShaker'); return variants[value('kurGlobuli')+'|'+shake+'|'+shaker]; }
  function update(){
    var shake=value('kurShake'), shaker=q('input[name="kurShaker"][value="shaker"]'), shakerOption=q('#kurShakerOption');
    shaker.disabled=shake==='none'; shakerOption.style.opacity=shake==='none'?'.45':'1'; shakerOption.style.pointerEvents=shake==='none'?'none':'auto';
    if(shake==='none') q('input[name="kurShaker"][value="none"]').checked=true;
    var id=currentId(), v=state.data && state.data.variants.find(function(x){return x.id===id;});
    var names=['Grundpaket']; if(value('kurGlobuli')==='globuli') names.push('Globuli'); if(shake!=='none') names.push('Daily One '+({vanille:'Vanille',erdbeere:'Erdbeere',schoko:'Schokolade'}[shake])); if(value('kurShaker')==='shaker' && shake!=='none') names.push('Shaker');
    q('#kurSummary').textContent=names.join(' + ');
    var price=v ? money.format(v.price/100) : 'Preis nicht verfügbar'; q('#kurPrice').textContent=price; q('#kurStickyPrice').textContent=price;
    q('#kurBuy').dataset.variantId=id; q('#kurStickyBuy').dataset.variantId=id;
  }
  async function add(event){
    var button=event.currentTarget; if(state.busy) return; var id=Number(button.dataset.variantId); var v=state.data && state.data.variants.find(function(x){return x.id===id;});
    if(!v || !v.available){q('#kurMessage').textContent='Diese Variante ist derzeit nicht lieferbar. Bitte wähle eine andere Zusammenstellung.';return;}
    state.busy=true; button.textContent='WIRD IN DEN WARENKORB GELEGT …';
    try { var r=await fetch(cartRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})}); if(!r.ok) throw new Error(); window.location.assign(cartRoot+'cart'); }
    catch(e){state.busy=false;q('#kurMessage').textContent='Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.';button.textContent='IN DEN WARENKORB';}
  }
  fetch(cartRoot+'products/stoffwechselkur.js',{headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error();return r.json();}).then(function(d){state.data=d;root.querySelectorAll('input[type="radio"]').forEach(function(e){e.addEventListener('change',update);});q('#kurBuy').addEventListener('click',add);q('#kurStickyBuy').addEventListener('click',add);update();}).catch(function(){q('#kurMessage').textContent='Die Paketpreise konnten gerade nicht geladen werden.';});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitacare-hero-ab-test"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cookieName = 'vc_home_hero';
    const initialize = (section) => {
      if (document.documentElement.dataset.vcHomeExperiment || section.dataset.vcInitialized === 'true') return;
      const stored = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`))?.split('=')[1];
      const requested = new URLSearchParams(window.location.search).get('vc_variant');
      const forced = requested === 'A' || requested === 'B';
      const variant = forced ? requested : stored === 'A' || stored === 'B' ? stored : Math.random() < 0.5 ? 'A' : 'B';
      if (!forced && !stored) document.cookie = `${cookieName}=${variant}; Max-Age=7776000; Path=/; SameSite=Lax`;
      section.querySelectorAll('[data-vc-variant]').forEach((element) => {
        element.hidden = element.dataset.vcVariant !== variant;
      });
      section.dataset.vcInitialized = 'true';
      section.dataset.activeVariant = variant;
      window.dataLayer = window.dataLayer || [];
      if (!forced) window.dataLayer.push({ event: 'vitacare_hero_view', hero_variant: variant });
    };
    document.querySelectorAll('[data-vc-hero-ab]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-vc-hero-ab]');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
